import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus'
import omit from '@/Core/utils/omit'
import { IFInitWalletRsp } from '@/api/apiRsp/IFWalletRsp'
import CurrencyComponent from '@/components/currencyComponent'
import SelectUI, { SelectOption, SelectUIProps } from '@/componentsUI/Select'
import React from 'react'
const Option = SelectOption
import './index.less'

export interface WidthdrawCurrencyProps extends SelectUIProps {
    //选项卡
    currencys: IFInitWalletRsp[]
}

const WidthdrawCurrency = (props: WidthdrawCurrencyProps) => {
    const { currencys } = props
    const { t } = useTranslationPlus('Wallet');
    const other = omit(props, ['currencys'])
    return (
        <div className='widthdraw-currency'>

            <SelectUI {...other}
                defaultActiveFirstOption={true}
                renderFormat={(optionD: any, value: any) => {
                    const option = currencys?.[optionD?.['_index']]
                    return option ? (
                        <div className={`custom-render`}>
                            <CurrencyComponent
                                currencyType={option?.currencyType}
                                serverCurrencyType={option?.serverCurrencyType} />
                            <span className={`balance`}>{t('Balance')}</span>
                            <CurrencyComponent
                                amount={option?.allBalance}
                                showIcon={false}
                                showUnit={false}
                                type={'valid9'}
                                currencyType={option?.currencyType}
                                serverCurrencyType={option?.serverCurrencyType} />
                        </div>
                    ) : (
                        <div>{value}</div>
                    )
                }}
            >
                {
                    currencys?.map((option: IFInitWalletRsp) => (
                        <Option
                            key={option?.currencyType}
                            value={option?.currencyType}
                            className={`option`}>
                            <CurrencyComponent
                                currencyType={option.currencyType}
                                serverCurrencyType={option.serverCurrencyType} />
                            <CurrencyComponent
                                className='select-balance'
                                amount={option?.balance}
                                showIcon={false}
                                showUnit={false}
                                type={'valid9'}
                                currencyType={option?.currencyType}
                                serverCurrencyType={option?.serverCurrencyType} />
                        </Option>
                    ))
                }
            </SelectUI>
        </div>
    )

}

export default WidthdrawCurrency
